import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { authStorageKey } from "../config.js";
import { useStickyState } from "../hooks/useStickyState.js";
import "../helpers/time.js";
const initSecurity = {
  token: null,
  refreshToken: null,
  authentication: null,
  missingConsents: null
};
const CredentialsContext = createContext(initSecurity);
const CredentialsContextChange = createContext(() => {
});
const CredentialsProvider = ({ children }) => {
  const [credentials, setCredentials] = useStickyState(initSecurity, authStorageKey);
  return /* @__PURE__ */ jsx(CredentialsContext.Provider, { value: credentials, children: /* @__PURE__ */ jsx(CredentialsContextChange.Provider, { value: setCredentials, children }) });
};
const useCredentials = () => {
  const context = useContext(CredentialsContext);
  if (context === void 0) {
    throw new Error("useCredentials must be used within the CredentialsProvider.");
  }
  return context || initSecurity;
};
const useSetCredentials = () => {
  const context = useContext(CredentialsContextChange);
  if (!context) {
    throw new Error("useSetCredentials must be used within the CredentialsProvider.");
  }
  return context;
};
export {
  CredentialsContext,
  CredentialsContextChange,
  CredentialsProvider,
  useCredentials,
  useSetCredentials
};
